/**
 * Styled Components - Created by david on 06/04/18.
 */
import styled from 'styled-components'
import DatePicker from 'antd/lib/date-picker'
import Button from 'antd/lib/button'
import Radio from 'antd/lib/radio'
import Tag from 'antd/lib/tag'
import Input from 'antd/lib/input'
import Select from 'antd/lib/select'
import {
  BLUE,
  BLUE_SHADOW,
  GRAY_LIGHT,
  GRAY_SHADOW,
  GRAY_DARK,
  WHITE,
  WHITE_SMOKE,
  WHITE_TRANSPARENT,
  GRAY,
  BLACK,
  GREEN_BRIGHT,
  GREEN,
  GRAY_STRONG,
  GRAY_BG,
  BLUE_LIGHT,
  TRANSPARENT,
} from '../../theme/colors'
import Icon from 'antd/lib/icon'
import Popover from 'antd/lib/popover'
import Spin from 'antd/lib/spin'

const { TextArea } = Input
const { Group } = Radio
const { CheckableTag } = Tag

interface DivProps {
  admin?: boolean
  secondary?: Boolean
  backgroundColor?: string
  color?: string
}

export const Container = styled.div`
  padding-bottom: 16px;
  position: relative;
  margin-top: -38px;
`

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 60vh;
  justify-content: center;
  align-items: center;
`

export const TransparentLoader = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  background: ${WHITE_TRANSPARENT};
  height: 100%;
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
`

export const LoadingContainerFix = styled.div`
  height: 100vh;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
`

export const Text = styled.div`
  color: ${WHITE};
`

export const PaginationRow = styled.div`
  text-align: right;
  padding-right: 36px;
  transition: all .25s;
  @media (min-width: 320px) and (max-width: 768px) {
    padding-right: 0;
    text-align: center;
  }
  ${({ backgroundColor }: DivProps) => backgroundColor ? `
    padding-right: 12px;
    margin-right: 34px;
    padding-left: 20px;
    border: 4px solid ${backgroundColor};
    border-radius: 10px;
    padding-bottom: 10px;
    @media (min-width: 320px) and (max-width: 768px) {
      margin-right: 0px;
      padding-left: 0px;
      margin-top: -48px;
      border-top-right-radius: 7px;
      padding-top: 48px;
      padding-bottom: 12px;
    }
  ` : ''}
`

export const TitleError = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
`

export const MessageError = styled.div`
  margin-top: 16px;
  font-size: 16px;
  line-height: 23px;
  text-align: center;
`

export const ConfirmMessage = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
`

export const MessageText = styled.div`
  max-width: ${({ admin }: DivProps) => (admin ? '100%' : '500px')};
  color: ${GRAY_DARK};
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 23px;
  margin-bottom: 20px;
  margin-top: ${({ admin }: DivProps) => (admin ? `20px` : 'none')};
  padding-bottom: ${({ admin }: DivProps) => (admin ? `12px` : 'none')};
  font-weight: ${({ admin }: DivProps) => (admin ? `bold` : 'none')};
  border-bottom: ${({ admin }: DivProps) =>
    admin ? `1px solid ${GRAY}` : 'none'};
  animation: fade-in-hor 0.3s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  @keyframes fade-in-hor {
    0% {
      transform: translateX(-5px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
`

export const MessagePrevent = styled.div`
  color: ${BLACK};
  margin-bottom: 18px;
  margin-top: -4px;
  animation: fade-in-hor 0.3s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  @keyframes fade-in-hor {
    0% {
      transform: translateX(-5px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  @media (min-width: 320px) and (max-width: 768px) {
    font-size: 12px;
  }
`

export const InputWrapper = styled.div`
  padding: 4px 0px;
  .ant-input:hover {
    border-color: ${BLUE};
  }

  .ant-input:focus {
    border-color: ${BLUE};
    outline: 0;
    -webkit-box-shadow: 0 0 0 2px ${BLUE_SHADOW};
    box-shadow: 0 0 0 2px ${BLUE_SHADOW};
  }

  .ant-input::selection {
    background: ${BLUE};
  }
`

export const StyledInput = styled(Input)`
  margin-bottom: 20px;
  margin-top: 0px;
  border-radius: 0px;
  width: 100%;
`

// Filter Related

const Search = Input.Search

export const SearchDiv = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 14px;
  align-items: center;
  @media (max-width: 1023px) {
    flex-wrap: wrap;
  }
`

export const SearchInput = styled(Search)`
  border-radius: 3px;
  width: 100%;
  max-width: 207px;
  margin-right: 15px;
  & input {
    border-radius: 3px;
    padding: 7px;
    height: 42px;
  }
  @media (max-width: 1023px) {
    margin-bottom: 12px;
    margin-top: 12px;
  }
  @media (min-width: 320px) and (max-width: 768px) {
    width: 98%;
    max-width: 100%;
    margin: 1%;
  }
`

export const FilterTitle = styled.div`
  color: #5F6062;
  font-size: 14px;
  font-weight: 600;
  line-height: 27px;
  position: absolute;
  left: -1px;
  top: -16px;
  background: white;
  width: fit-content;
  padding: 0px 14px;
  margin-bottom: 16px;
  border-radius: 5px;
  box-shadow: 0px -2px 2px -1px #eaeaea;
  border-left: 1px solid #e2e2e2;
  border-bottom-left-radius: 0;
  border-right: 1px solid #f4f4f4;
  border-bottom-right-radius: 0;
`

export const Separator = styled.div`
  height: 8px;
  @media (max-width: 768px) {
    height: 16px;
  }
  @media (max-width: 544px) {
    height: 0px;
  }
`

export const Filters = styled.div`
  border: 1px solid ${GRAY_LIGHT};
  margin-left: 4px;
  padding: 20px;
  margin-bottom: 14px;
  display: flex;
  margin-right: 36px;
  box-shadow: 2px 2px 7px ${GRAY_SHADOW};
  flex-direction: column;
  border-radius: 5px;
  border-top-left-radius: 0;
  animation: fade-in-top 0.3s cubic-bezier(0.39, 0.575, 0.565, 1) 0.15s both;
  @keyframes fade-in-top {
    0% {
      transform: translateY(-5px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
  @media (min-width: 2000px) {
    width: fit-content;
  }
  @media (max-width: 1023px) {
    padding-top: 8px;
  }
  @media (min-width: 320px) and (max-width: 768px) {
    padding: 10px;
    margin-right: 12px;
  }
`

export const StyledSelect = styled(Select)`
  width: 20%;
  max-width: 208px;
  height: 40px;
  margin-right: 15px;
  & .ant-select-selection {
    border-radius: 3px;
    height: 40px;
    line-height: 40px;
    & div {
      line-height: 40px;
    }
  }
  @media (max-width: 1023px) {
    flex: 1;
    margin-top: 12px;
    margin-bottom: 12px;
  }
  @media (min-width: 320px) and (max-width: 768px) {
    width: 48%;
    margin: 1%;
  }
`

export const Options = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 1023px) {
    flex-wrap: wrap;
  }
  @media (min-width: 320px) and (max-width: 768px) {
    flex-flow: wrap;
  }
`

export const SubOptions = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: -38px;
  flex-flow: column;
  align-items: stretch;
  animation: fade-in-top 0.3s cubic-bezier(0.39, 0.575, 0.565, 1) 0.3s both;
  @keyframes fade-in-top {
    0% {
      transform: translateY(-5px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
  @media (min-width: 2000px) {
    width: fit-content;
  }
  @media (min-width: 320px) and (max-width: 768px) {
    flex-flow: column;
    margin-bottom: unset;
  }
`

export const StyledDatePicker = styled(DatePicker)`
  width: 20%;
  max-width: 148px;
  height: 40px;
  margin-right: 15px;
  input {
    border-radius: 3px;
    height: 40px;
  }
  @media (max-width: 1023px) {

  }
  @media (min-width: 320px) and (max-width: 768px) {
    width: 48%;
    margin: 1%;
  }
`

interface ButtonWrapperProps {
  disabled: boolean
}

export const StyledButton = styled(Button)`
  height: 40px;
  border-radius: 3px;
  width: 100%;
  @media (min-width: 320px) and (max-width: 768px) {
    width: 100%;
  }
`

export const ButtonWrapper = styled.div`
  max-width: 150px;
  width: 100%;
  .ant-btn-primary {
    background-color: ${({ disabled }: ButtonWrapperProps) =>
      disabled ? WHITE_SMOKE : BLUE};
    border-color: ${({ disabled }: ButtonWrapperProps) =>
      disabled ? WHITE_SMOKE : BLUE};
  }
  .ant-btn-primary:hover {
    background-color: ${({ disabled }: ButtonWrapperProps) =>
      disabled ? WHITE_SMOKE : BLUE};
    border-color: ${({ disabled }: ButtonWrapperProps) =>
      disabled ? WHITE_SMOKE : BLUE};
  }

  @media (min-width: 320px) and (max-width: 768px) {
    margin: 1%;
    width: 100%;
  }
`

export const HelpWrapper = styled.div`
  position: absolute;
  margin-top: -50px;
  right: 50px;
  font-size: 16px;
  @media (min-width: 320px) and (max-width: 1000px) {
    position: inherit;
    margin-top: -20px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    text-align: end;
    align-items: flex-end;
  }
  @media (max-width: 768px) {
    flex-flow: row;
    justify-content: flex-end;
    right: 0;
    align-items: center;
  }
  @media (max-width: 544px) {
    flex-flow: column;
    align-items: flex-end;
    padding-top: 18px;
  }
`

export const HelpMessage = styled.span`
  margin-right: 8px;
  @media (min-width: 320px) and (max-width: 768px) {
    margin-right: 17px;
  }
`

export const HelpLink = styled.span`
  color: ${WHITE};
  background: ${GREEN_BRIGHT};
  font-weight: bold;
  font-family: Avenir;
  border-radius: 5px;
  padding: 5px 10px;
  font-size: 14px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  @media (min-width: 320px) and (max-width: 1023px) {
    margin-top: 6px;
    margin-right: 8px;
  }
  @media (max-width: 768px) {
    margin-top: 0px;
  }
  @media (max-width: 544px) {
    margin-top: 6px;
  }
`

export const CertifyWrapper = styled.div`
  position: absolute;
  margin-top: -54px;
  right: 50px;
  font-size: 16px;
  display: flex;
  align-items: center;
  @media (min-width: 320px) and (max-width: 1000px) {
    position: inherit;
    margin-top: -20px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    text-align: end;
    align-items: flex-end;
  }
  @media (max-width: 768px) {
    flex-flow: row;
    justify-content: flex-end;
    right: 0;
    align-items: center;
  }
  @media (max-width: 544px) {
    flex-flow: column;
    align-items: flex-end;
    padding-top: 18px;
  }
`

export const CertifyMessage = styled.span`
  margin-right: 14px;
  font-size: 12px;
  text-align: right;
  display: inline-flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-flow: column;
  @media (min-width: 320px) and (max-width: 768px) {
    margin-right: 17px;
  }
  @media (max-width: 600px) {
    max-width: 334px;
  }
`

export const CertifyLink = styled.span`
  color: #4b4b4b;
  background: #00e1ff;
  font-weight: bold;
  font-family: Avenir;
  border-radius: 3px;
  padding: 3px 10px;
  font-size: 14px;
  transition: all .25s;
  display: flex;
  align-items: center;
  box-shadow: 1px 2px 3px -1px #b7b7b7;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  @media (min-width: 320px) and (max-width: 1023px) {
    margin-top: 6px;
    margin-right: 8px;
  }
  @media (max-width: 768px) {
    margin-top: 0px;
  }
  @media (max-width: 544px) {
    margin-top: 6px;
  }
`

export const ProCertifyIcon = styled.img`
  max-width: 22px;
  margin-left: 4px;
  margin-right: -2px;
`

export const AnimatedDiv = styled.div`
  position: fixed;
  bottom: 24px;
  left: 30px;
  z-index: 3;
`

export const BounceDiv = styled.div`
  ${({ secondary }: DivProps) =>
    secondary
      ? `
  animation: wobble-hor-bottom 0.8s 0s 2 both;
  @keyframes wobble-hor-bottom {
    0%, 20%, 50%, 80%, 100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-15px);
    }
    60% {
      transform: translateY(-7px);
      filter: grayscale(0.7);
    }
  }
  `
      : ''}
`

export const CartIcon = styled.div`
  background: ${WHITE};
  border-radius: 50%;
  width: 68px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 68px;
  box-shadow: 0px 1px 9px -2px #6e6e6e;
  transition: all 0.25s;
  .ant-badge-count {
    transform: translateX(30%);
  }
  animation: fade-in-leftDesuZ 0.5s cubic-bezier(0.39, 0.575, 0.565, 1) 1s both;
  @keyframes fade-in-leftDesuZ {
    0% {
      transform: translateX(-30px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  &:hover {
    cursor: pointer;
    filter: opacity(0.7);
  }
`

export const ShoppingCartIcon = styled(Icon)`
  font-size: 32px;
  color: ${BLACK};
`

export const CartDiv = styled.div`
  position: fixed;
  background: white;
  height: 100vh;
  max-width: 428px;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 999;
  box-shadow: 1px 0px 14px 4px #b8b8b8;
  animation: slide-in-left 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  @keyframes slide-in-left {
    0% {
      transform: translateX(-450px);
    }
    100% {
      transform: translateX(0);
    }
  }
`

export const CartTitle = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 22px 26px;
  background: #202020;
  color: ${WHITE};
`

export const CartTitleLabel = styled.div`
  display: flex;
  align-items: center;
`

export const CloseIcon = styled(Icon)`
  transition: all 0.25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const CartIconMini = styled(Icon)`
  font-size: 18px;
  margin-right: 12px;
  margin-top: -3px;
  color: #fff7da;
`

export const CartList = styled.div`
  display: flex;
  flex-flow: column;
  margin-top: 30px;
  overflow-y: scroll;
  height: calc(100% - 146px);
`

export const CartItemDiv = styled.div`
  display: flex;
  margin-bottom: 18px;
  margin-left: 8px;
  margin-right: 8px;
`

export const CartThumbnail = styled.img`
  max-width: 128px;
  width: 100%;
  object-fit: cover;
  height: 122px;
`

export const CartInfo = styled.div`
  display: flex;
  flex-flow: column;
  position: relative;
  margin-top: 4px;
  margin-left: 10px;
  flex: 1;
  padding-right: 54px;
`

export const DesignName = styled.div`
  font-weight: bold;
  font-size: 16px;
  font-family: Avenir;
`

export const DesignCode = styled.div`
  margin-top: 4px;
`

export const ProductName = styled.div`
  font-size: 12px;
  margin-top: 4px;
`

export const Quantity = styled.div`
  position: absolute;
  right: 13px;
  top: calc(50% - 5px);
  background: #202020;
  height: 22px;
  border-radius: 50px;
  color: white;
  font-size: 10px;
  width: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const DeleteIcon = styled(Icon)`
  position: absolute;
  right: 13px;
  top: 1px;
  height: 22px;
  border-radius: 50px;
  color: #202020;
  font-size: 10px;
  width: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
    border: 1px solid gray;
  }
`

export const CartButtonOpen = styled.div`
  margin: 0 auto;
  text-align: center;
  width: 90%;
  background: #202020;
  color: white;
  margin-top: 8px;
  margin-bottom: 8px;
  padding: 11px 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  transition: all 0.25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const GenderName = styled.div`
  font-size: 12px;
  margin-top: 6px;
`

export const SizeName = styled.div`
  font-size: 12px;
  margin-top: 2px;
`

export const UpgradeName = styled.div`
  font-size: 12px;
  margin-top: 2px;
`

export const UpgradeValue = styled.div`
  font-family: Avenir;
  font-weight: bold;
  display: inline-block;
  margin-left: 4px;
`

export const StyledTooltip = styled(Popover)`
  z-index: 12;
  position: absolute;
  top: -49px;
  left: 107px;
  @media (max-width: 768px) {
    top: -22px;
    left: 56vw;
  }
  @media (max-width: 616px) {
    left: 58vw;
  }
  @media (max-width: 468px) {
    left: 61vw;
  }
`

export const CouponIcon = styled.img`
  max-width: 88px;
  z-index: 12;
  position: absolute;
  top: -62px;
  left: 157px;
  animation: bounce-in-top 0.65s both;
  @keyframes bounce-in-top {
    0% {
      -webkit-transform: translateY(-25px);
              transform: translateY(-25px);
      -webkit-animation-timing-function: ease-in;
              animation-timing-function: ease-in;
      opacity: 0;
    }
    38% {
      -webkit-transform: translateY(0);
              transform: translateY(0);
      -webkit-animation-timing-function: ease-out;
              animation-timing-function: ease-out;
    }
    55% {
      -webkit-transform: translateY(-20px);
              transform: translateY(-20px);
      -webkit-animation-timing-function: ease-in;
              animation-timing-function: ease-in;
    }
    72% {
      -webkit-transform: translateY(0);
              transform: translateY(0);
      -webkit-animation-timing-function: ease-out;
              animation-timing-function: ease-out;
      opacity: 1;
    }
    81% {
      -webkit-transform: translateY(-8px);
              transform: translateY(-8px);
      -webkit-animation-timing-function: ease-in;
              animation-timing-function: ease-in;
    }
    90% {
      -webkit-transform: translateY(0);
              transform: translateY(0);
      -webkit-animation-timing-function: ease-out;
              animation-timing-function: ease-out;
    }
    95% {
      -webkit-transform: translateY(-4px);
              transform: translateY(-4px);
      -webkit-animation-timing-function: ease-in;
              animation-timing-function: ease-in;
    }
    100% {
      -webkit-transform: translateY(0);
              transform: translateY(0);
      -webkit-animation-timing-function: ease-out;
              animation-timing-function: ease-out;
    }
  }
  @media (max-width: 1114px) {
    top: -22px;
    left: 147vw;
  }
  @media (max-width: 768px) {
    top: -36px;
    left: 14vw;
  }
  @media (max-width: 468px) {
    left: 72vw;
  }
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const TextBody = styled.div``

export const TooltipBody = styled.div`
  padding-left: 8px;
  padding-right: 10px;
  max-width: 376px;
  width: 100%;
  @media (max-width: 767px) {
    padding-top: 30px;
    padding-left: 19px;
    padding-right: 17px;
  }
`

export const InfoIcon = styled(Icon)`
  margin-left: 9px;
  font-size: 16px;
  vertical-align: sub;
  color: ${BLUE};
  z-index: 20;
  &:hover {
    cursor: pointer;
  }
`

export const TitleTransfer = styled.div`
  text-align: center;
  font-weight: bold;
  font-family: Avenir;
  font-size: 20px;
  margin: 0 auto;
`

export const TitleTransferSent = styled.div`
  text-align: center;
  font-weight: bold;
  font-family: Avenir;
  font-size: 20px;
  margin: 0 auto;
  color: ${GREEN_BRIGHT};
`

export const ThumbnailSection = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  justify-content: center;
  margin-left: 28px;
`

export const ProductThumbnail = styled.img`
  max-width: 128px;
  border-radius: 50%;
  z-index: 2;
  box-shadow: -1px 2px 4px 1px #bababa;
`

export const RightSide = styled.div``

export const RecommendedText = styled.div`
  font-size: 14px;
  border-radius: 5px;
  margin-left: -3px;
  padding: 4px 8px;
  text-align: left;
`

export const ProductNameLabel = styled.div`
  text-align: left;
  padding-left: 40px;
  margin-top: 6px;
  background: #d8f1ff;
  margin-left: -16px;
  border-radius: 50px;
  width: fit-content;
  padding-right: 12px;
  padding-top: 2px;
  padding-bottom: 0px;
`

export const DescriptionLabel = styled.div`
  text-align: left;
  padding-left: 43px;
  margin-top: 6px;
  background: #fff2c9;
  margin-left: -39px;
  border-radius: 50px;
  width: fit-content;
  padding-right: 12px;
  font-weight: normal;
  font-size: 14px;
  padding-top: 2px;
  padding-bottom: 2px;
`

export const TransferBody = styled.div`
  margin: 22px 0 28px 0px;
  text-align: center;
`

export const TransferText = styled.div``

export const RadioGroupStyled = styled(Group)`
  margin: 0 auto;
  margin-left: 6px;
  display: inline-flex;
  flex-flow: column;
  width: auto;
  margin-bottom: 14px;
  margin-top: 12px;
`

export const RadioStyled = styled(Radio)`
  font-size: 14px;
  margin-right: 0;
  margin-bottom: 10px;
  display: inline-flex;
  align-items: center;
  .ant-radio {
    opacity: 0.7;
  }
  .ant-radio-inner {
    width: 12px;
    height: 12px;
  }
  span.ant-radio + * {
    padding-left: 5px;
  }
  .ant-radio-inner:after {
    width: 8px;
    height: 8px;
    left: 1px;
    top: 1px;
  }
`

export const StyledInputTransfer = styled(TextArea)`
  border-radius: 3px;
  margin-bottom: 16px;
  input {
    border-radius: 3px;
    width: 100%;
  }
`

export const StyledSpin = styled(Spin)`
  margin-bottom: -8px;
  filter: brightness(5) contrast(5.5);
  margin-top: -8px;
`

export const TransferButton = styled.div`
  margin: 0 auto;
  width: 112px;
  background: ${BLUE};
  display: block;
  margin-top: 8px;
  margin-bottom: -34px;
  padding: 10px 16px;
  border-radius: 3px;
  color: ${WHITE};
  transition: all .25s;
  box-shadow: 0px 2px 6px -1px #a1a1a1;
  &:hover {
    cursor: pointer;
    color: ${BLUE};
    background: ${WHITE};
  }
`

export const CancelTransfer = styled.div`
  margin: 0 auto;
  margin-top: 22px;
  margin-bottom: -28px;
  box-shadow: 0px 2px 5px -1px #a1a1a1;
  width: fit-content;
  border-radius: 5px;
  padding: 7px 12px;
  &:hover {
    cursor: pointer;
  }
`

export const TitleCoupon = styled.div`
  text-align: center;
  font-weight: bold;
  font-family: Avenir;
  font-size: 20px;
  max-width: 178px;
  margin: 0 auto;
`

export const CouponBody = styled.div`
  margin: 22px 0 28px -38px;
  text-align: center;
`

export const UseCode = styled.div`
  font-weight: bold;
  font-family: Avenir;
`

export const CouponDiv = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const CouponImage = styled.img`
  max-width: 146px;
  margin: 4px;
`

export const CouponLabel = styled.div`
  position: absolute;
  margin-top: 8px;
  margin-right: 40px;
  font-size: 11px;
  color: white;
  font-weight: bold;
  font-family: Avenir;
`

export const CopyLabel = styled.div`
  position: absolute;
  margin-bottom: -42px;
  font-size: 8.75px;
  margin-left: -38px;
  color: white;
  font-family: Avenir;
`

export const ActSoon = styled.div``

export const BottomLabel = styled.div`
  margin-top: 28px;
  font-size: 12px;
  margin-bottom: -32px;
`

export const ModalTitleDisabled = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
`

export const IconPrint = styled(Icon)`
  margin-right: 12px;
`

export const ModalTitlePrompt = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
`

export const ModalTitleCentered = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
  text-align: center;
`

export const InfoBody = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: -38px;
`

export const InfoBodyCentered = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: -38px;
  text-align: center;
`

export const InfoTitle = styled.div`
  text-align: center;
  margin-top: -10px;
  font-size: 18px;
  font-weight: bold;
  font-family: Avenir;
  margin-bottom: 24px;
`

export const ErrorSection = styled.div`
  text-align: center;
  margin-bottom: 44px;
`

export const ErrorIcon = styled(Icon)`
  margin-right: 10px;
  color: orange;
`

export const ErrorDiv = styled.div`
  span {
    font-weight: 500;
  }
  font-family: Avenir;
`

export const deleteButtonStyle = {
  background: BLUE,
  color: WHITE,
  border: 'none',
}

export const buttonStyle = {
  background: BLUE,
  border: 'none',
}

export const ProTitle = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
`

export const ProCertification = styled.div`
  font-weight: bold;
  font-family: Avenir;
  font-size: 16px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`

export const ProCertifyIconModal = styled.img`
  margin-left: 12px;
  max-width: 26px;
  border-radius: 25px;
`

export const ProCertificationSub = styled.div``

export const GetYourDesigns = styled.div`
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 6px;
  font-family: Avenir;
`

export const ProOptional = styled.div`
  font-style: italic;
  font-size: 12px;
`

export const PlanSelection = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-top: 12px;
  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`

export const PlanDiv = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: flex-start;
  max-width: 366px;
  box-shadow: 0px 2px 7px 0px #bdbdbd;
  padding: 14px 28px;
  border-radius: 5px;
  position: relative;
  transition: all .3s;
  margin-right: 32px;
  min-height: 556px;
  border: ${({ secondary }: DivProps) => secondary ? `1px solid ${BLUE}` : ''};
  &:hover {
    cursor: pointer;
    box-shadow: 0px 2px 9px -1px #7f7f7f;
    transform: scale(1.007);
  }
  &:last-child {
    margin-right: 0px;
  }
  @media (max-width: 1024px) {
    margin-right: 0px;
  }
  @media (max-width: 768px) {
    margin-bottom: 28px;
    max-width: 378px;
    min-height: unset;
  }
`

export const MostPopular = styled.div`
  position: absolute;
  top: -12px;
  padding: 2px 8px;
  border-radius: 5px;
  background: #a2df84;
  color: #292929;
  font-size: 12px;
`

export const PlanTitle = styled.div`
  font-weight: bold;
  margin-top: 4px;
  margin-bottom: 20px;
  font-family: Avenir;
`

export const PriceDiv = styled.div`
  display: flex;
  align-items: baseline;
  font-size: 12px;
  font-style: italic;
`

export const PriceValue = styled.div`
  font-size: 24px;
  margin-left: 26px;
  font-style: normal;
  font-weight: bold;
  font-family: Avenir;
  margin-right: 6px;
`

export const PlanDescription = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  font-size: 12px;
  margin-top: 20px;
`

export const DescriptionEntry = styled.div`
  margin-bottom: 10px;
`

export const CheckIcon = styled(Icon)`
  margin-right: 8px;
  color: ${GREEN};
`

export const PlanImages = styled.div`
  display: flex;
  align-items: center;
  flex-flow: column;
  flex: 1;
  justify-content: center;
`

export const PlanPicture = styled.img`
  max-width: 138px;
`

export const PlanImage = styled.img`
  max-width: 57px;
  margin-top: 16px;
  margin-bottom: 21px;
  @media (max-width: 698px) {
    max-width: 50px;
  }
`

export const PlanDetails = styled.ul`
  padding-left: 23px;
  font-size: 12px;
  background: #fffaec;
  padding-top: 10px;
  padding-bottom: 12px;
  padding-right: 18px;
  border-radius: 3px;
  li {
    margin-bottom: 8px;
  }
`

export const BottomActions = styled.div`
  display: flex;
  align-items: flex-end;
`

export const EmptyCircle = styled.div`
  height: 18px
  width: 18px;
  border: 2px solid ${GRAY};
  border-radius: 25px;
  margin-top: 10px;
  transition: all .25s;
  &:hover {
    color: ${BLUE};
  }
`

export const SelectButton = styled(Icon)`
  font-size: 18px;
  margin-top: 10px;
  color: ${BLUE};
`

export const BottomButtons = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 20px;
  margin-bottom: 0;
  margin-top: 32px;
  align-items: center;
  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`

export const InfoPrint = styled.div`
  color: ${BLUE};
  text-decoration: underline;
  transition: all .25s;
  font-size: 18px;
  font-weight: bold;
  font-family: Avenir;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
  @media (max-width: 698px) {
    margin-bottom: 24px;
  }
`

export const RightButtons = styled.div`
  display: flex;
`

export const NoThanks = styled(Button)`
  box-shadow: 0px 1px 4px -1px silver;
`

export const ContinueButton = styled(Button)`
  margin-left: 20px;
  box-shadow: 0px 1px 3px 0px silver;
  color: ${({ disabled }: ButtonWrapperProps) =>
    disabled ? GRAY_LIGHT : WHITE};
  background-color: ${({ disabled }: ButtonWrapperProps) =>
    disabled ? WHITE_SMOKE : BLUE};
  border-color: ${({ disabled }: ButtonWrapperProps) =>
    disabled ? WHITE_SMOKE : BLUE};

  &:hover {
    background-color: ${({ disabled }: ButtonWrapperProps) =>
      disabled ? WHITE_SMOKE : BLUE};
    border-color: ${({ disabled }: ButtonWrapperProps) =>
      disabled ? WHITE_SMOKE : BLUE};
  }
`

export const InfoSection = styled.div`
  display: flex;
  margin-bottom: 28px;
  @media (max-width: 698px) {
    flex-flow: column;
    align-items: center;
  }
`

export const DescriptionSection = styled.div`
  margin-left: 32px;
  @media (max-width: 698px) {
    margin-left: 0px;
    margin-top: 20px;
  }
`

export const InfoImage = styled.img`
  max-width: 220px;
  border-radius: 3px;
`

export const InfoSub = styled.div`
  font-size: 14px;
  font-family: Avenir;
`

export const SmallInfo = styled.div`
  font-size: 11px;
  font-style: italic;
  font-weight: 500;
  line-height: normal;
  font-family: Avenir;
  margin-bottom: 18px;
`

export const GoodReasons = styled.div`
  font-weight: bold;
  font-family: Avenir;
  margin: 12px 0;
`

export const ReasonsList = styled.div`
  font-size: 14px;
  font-family: Avenir;
  ul {
    padding-left: 18px;
  }
  li {
    margin-bottom: 8px;
  }
`

export const EditContent = styled.div`
  margin: 22px 0 28px -38px;
  text-align: center;
`

export const TitleEdit = styled.div`
  text-align: center;
  font-weight: bold;
  font-family: Avenir;
`

export const ImageDiv = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const DaysAmount = styled.div`
  position: absolute;
  font-weight: bold;
  color: black;
  font-size: 16px;
`
export const cancelButtonStyle = {
  background: WHITE,
  color: GRAY_DARK,
  borderColor: GRAY_LIGHT,
  boxShadow: 'none'
}

export const CircleEmpty = styled.div`
  width: 12px;
  height: 12px;
  display: inline-block;
  border: 1px solid #dddddd;
  vertical-align: middle;
  border-radius: 25px;
  margin-right: 7px;
  margin-bottom: 2px;
`

export const CircleIcon = styled(Icon)`
  margin-right: 8px;
`

export const CheckboxArchived = styled(CheckableTag)`
  border-radius: 25px;
  height: fit-content;
  padding: 0px 10px;
  display: inline-block;
  font-size: 12px;
  font-weight: normal;
  margin-right: 18px;
  margin-left: 2px;
  &.ant-tag {
    color: ${GRAY_STRONG};
    border-color: ${GRAY_BG};
  }
  &.ant-tag-checkable-checked {
    color: ${BLUE};
    border-color: ${BLUE};
    background: ${WHITE};
  }
  &.ant-tag-checkable:not(.ant-tag-checkable-checked):hover {
    color: ${BLUE_LIGHT};
  }
  &.ant-tag-checkable:active {
    background: ${TRANSPARENT};
  }
  @media (max-width: 767px) {
    display: none;
  }
`

export const CheckboxArchivedMobile = styled(CheckableTag)`
  border-radius: 25px;
  height: fit-content;
  padding: 0px 10px;
  display: inline-block;
  font-size: 12px;
  font-weight: normal;
  margin-left: 42px;
  display: none;
  &.ant-tag {
    color: ${GRAY_STRONG};
    border-color: ${GRAY_BG};
  }
  &.ant-tag-checkable-checked {
    color: ${BLUE};
    border-color: ${BLUE};
    background: ${WHITE};
  }
  &.ant-tag-checkable:not(.ant-tag-checkable-checked):hover {
    color: ${BLUE_LIGHT};
  }
  &.ant-tag-checkable:active {
    background: ${TRANSPARENT};
  }
  @media (max-width: 767px) {
    display: block;
    width: fit-content;
    margin: 0 auto;
    margin-bottom: 16px;
    margin-top: -4px;
  }
`

export const ExpiryDate = styled.div`
  margin: 0 auto;
  margin-top: 6px;
  color: #868686;
  margin-bottom: -12px;
  background: #f7f7f7;
  width: fit-content;
  padding: 3px 10px;
  border-radius: 25px;
  font-size: 13px;
`

export const ViewMode = styled.div`
  margin-top: 12px;
  margin-bottom: -16px;
  margin-left: 6px;
  font-size: 13px;
  font-family: Avenir;
  z-index: 90;
  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-flow: row-reverse;
    width: fit-content;
    align-self: flex-end;
    margin-top: 10px;
    padding: 0px 18px;
    padding-right: 0px;
    margin-bottom: -6px;
    border: 1px solid #dadada;
    margin-right: 32px;
    border-radius: 5px;
    color: #6a8cc8;
  }
  @media (max-width: 698px) {
    margin-right: 18px;
    margin-bottom: 0px;
    background: ${WHITE};
  }
  &:hover {
    cursor: pointer;
  }
`

export const ViewModeButton = styled.img`
  width: 33px;
  height: 32px;
  margin-right: 12px;
  padding: 6px;
  object-fit: contain;
  border: 1px solid #e7e7e7;
  border-radius: 5px;
  background: ${WHITE};
  box-shadow: 0px 2px 4px -1px #dcdcdc;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: #f9f9f9;
  }
  @media (max-width: 768px) {
    margin-right: -2px;
    margin-left: 14px;
    margin-top: -2px;
    margin-bottom: -2px;
  }
`

export const ActionButtons = styled.div`
  position: fixed;
  display: flex;
  flex-flow: column;
  align-items: flex-end;
  border-top-left-radius: 95px;
  background: linear-gradient(314deg, #5b5b5b33, #ffffff0a, transparent);
  bottom: 0;
  padding-bottom: 26px;
  right: 0;
  padding-right: 26px;
  padding-left: 20px;
  @media (max-width: 698px) {
    border-top-left-radius: 95px;
    background: linear-gradient(314deg, #5b5b5bb5, #ffffff0a, transparent);
    bottom: 0;
    padding-bottom: 26px;
    right: 0;
    padding-right: 26px;
    padding-left: 20px;
  }
  animation: fade-in-rightactions 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-rightactions {
    0% {
      transform: translateX(10px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
`

export const TotalDesigns = styled.div`
  background: #f1f4f5;
  padding: 4px 12px;
  border-radius: 5px;
  font-size: 12px;
  margin-right: -30px;
  padding-right: 30px;
  padding-left: 16px;
  color: #3a3a3a;
`

export const Clear = styled.div`
  display: flex;
  align-items: center;
  margin-top: 18px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const MoveToFolder = styled.div`
  display: flex;
  align-items: center;
  margin-top: 18px;
  transition: all .25s;
  
  @media (min-width: 1025px) {
    &:hover {
      cursor: pointer;
      opacity: 0.7;
    }
  }
`

export const FolderButtonList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: 1px solid #88c8ed;
  border-radius: 5px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 10px;
  margin-top: 10px;
  background: white;
  box-shadow: 1px 2px 4px -2px #b4b4b4;
  animation: fade-in-top-folders-list 0.5s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;

  @keyframes fade-in-top-folders-list {
  0% {
    transform: translateY(-25px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
`

export const SpinContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: 1px solid #88c8ed;
  border-radius: 5px;
  padding-top: 18px;
  padding-bottom: 12px;
  padding-left: 31px;
  padding-right: 31px;
  margin-top: 10px;
  background: white;
  box-shadow: 1px 2px 4px -2px #b4b4b4;
`

export const FolderButton = styled.div`
  display: flex;
  align-items: center;
  margin-top: 18px;
  transition: all .25s;
  font-size: 14px;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const DeleteDesigns = styled.div`
  display: flex;
  align-items: center;
  margin-top: 18px;
  font-size: 13px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const DeleteLabel = styled.div`
  background: #f8d2d2;
  padding: 4px 12px;
  border-radius: 25px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  padding-right: 20px;
  margin-right: -6px;
  box-shadow: 1px 2px 4px -2px #b4b4b4;
  color: #3a3a3a;
  @media (max-width: 698px) {
    box-shadow: 1px 2px 4px -2px #000000;
  }
`

export const RemoveIcon = styled(Icon)`
  color: #aa3030;
  background: white;
  border: 1px solid #e6b6b6;
  padding: 12px;
  border-radius: 25px;
  box-shadow: 1px 2px 4px -1px #868686;
  @media (max-width: 698px) {
    box-shadow: 1px 2px 4px -1px #000000;
  }
`

export const ClearLabel = styled.div`
  background: #f9e3c5;
  padding: 4px 12px;
  border-radius: 25px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  padding-right: 20px;
  margin-right: -6px;
  box-shadow: 1px 2px 4px -2px #b4b4b4;
  color: #3a3a3a;
  @media (max-width: 698px) {
    box-shadow: 1px 2px 4px -2px #000000;
  }
`

export const MoveToFolderLabel = styled.div`
  background: #88c8ed;
  padding: 4px 12px;
  border-radius: 25px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  padding-right: 20px;
  margin-right: -6px;
  box-shadow: 1px 2px 4px -2px #b4b4b4;
  color: #3a3a3a;
  @media (max-width: 698px) {
    box-shadow: 1px 2px 4px -2px #000000;
  }
`

export const ClearIcon = styled(Icon)`
  color: #b18226;
  background: white;
  border: 1px solid #eed098;
  padding: 12px;
  border-radius: 25px;
  box-shadow: 1px 2px 4px -1px #868686;
  @media (max-width: 698px) {
    box-shadow: 1px 2px 4px -1px #000000;
  }
`

export const MoveToFolderIcon = styled(Icon)`
  color: #378bbb;
  background: ${WHITE};
  border: 1px solid #88c8ed;
  padding: 12px;
  border-radius: 25px;
  box-shadow: 1px 2px 4px -1px #868686;
  @media (max-width: 698px) {
    box-shadow: 1px 2px 4px -1px #000000;
  }
`

export const FolderIcon = styled(Icon)`
  color: ${({ color }: DivProps) => (color ? color : 'unset')};
  margin-right: 8px;
`

export const EmptyFolder = styled.div`
  text-align: center;
  margin-bottom: 36px;
  padding-top: 28px;
  font-style: italic;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MyLocker/styledComponents.tsx